<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.nuclearmedia.com" class="font-weight-bold ml-1" target="_blank">Nuclear Media Inc.</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <!--<li class="nav-item">
            <a href="https://www.nuclearmedia.com" class="nav-link" target="_blank">Nuclear Media</a>
          </li>-->
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
